import { FormEventHandler, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Input } from 'ui/input'
import { LoadingButton } from 'ui/loading-button'
import { toast } from 'ui/sonner'

import { apiClient } from '~/api/client'
import { LinkButton } from '~/components/link-button'

import { AuthForm } from '../components/auth-form'

export const Forgot = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)

  const { t } = useTranslation()

  const onSubmit: FormEventHandler = e => {
    e.preventDefault()
    setIsLoading(true)
    const email = ((e.currentTarget as HTMLFormElement).elements.namedItem('email') as HTMLInputElement).value
    if (!email) return

    void apiClient
      .POST('/auth/forgot', { body: { email } })
      .then(({ response }) => {
        setIsLoading(false)
        if (response.status === 401) return toast.error(t('No such user'))

        if (response.status >= 400) return toast.error(t('Something went wrong'))

        setIsSuccess(true)
      })
      .finally(() => setIsLoading(false))
  }

  if (isSuccess)
    return (
      <AuthForm>
        <h3 className="text-center text-lg">{t('Thank you for submitting the form')}</h3>
        <p>
          {t(
            'We ve just sent an email to the address associated with your account Please check your inbox for further instructions on resetting your password',
          )}
        </p>
        <LinkButton to="/auth/login" variant="outline">
          {t('Back to login')}
        </LinkButton>
      </AuthForm>
    )

  return (
    <AuthForm onSubmit={onSubmit}>
      <Input autoComplete="email" name="email" placeholder={t('Email')} type="email" required />
      <LoadingButton isLoading={isLoading} type="submit">
        {t('Continue')}
      </LoadingButton>
      <LinkButton to="/auth/login" variant="outline">
        {t('Back to login')}
      </LinkButton>
    </AuthForm>
  )
}
